exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apc-react-body .content.col2 {\n  column-count: 2;\n  column-gap: 20px; }\n\n.apc-react-body .content label.domain {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  min-width: 100px; }\n  .apc-react-body .content label.domain span.domain-name.draft {\n    color: #BBBBBB; }\n  .apc-react-body .content label.domain i {\n    font-size: 55%;\n    margin-left: 10px; }\n    .apc-react-body .content label.domain i.live {\n      color: #06DB82; }\n    .apc-react-body .content label.domain i.draft {\n      color: #BBBBBB; }\n", ""]);

// exports
